<template>
  <div :class='classes'>
    <w-row v-if='withUserDataTitle === true'>
      <w-column class='pb-0'>
        <h5>{{ $t('Common.contact') }}</h5>
      </w-column>
    </w-row>
    <w-row v-if='showSalutationField'>
      <w-column cols='auto'>
        <label>{{ salutation }}</label>
      </w-column>
    </w-row>
    <w-row v-if='showTitleField || showNameField'>
      <w-column
        v-if='showTitleField'
        cols='auto'
      >
        <label>{{ title }}</label>
      </w-column>
      <w-column
        v-if='showNameField'
        cols='auto'
      >
        <label>{{ firstname }} {{ lastname }}</label>
      </w-column>
    </w-row>
    <w-row v-if='showBirthdayField'>
      <w-column cols='auto'>
        <label>{{ birthday }}</label>
      </w-column>
    </w-row>
    <w-row v-if='showPostalSalutationField'>
      <w-column cols='auto'>
        <label>{{ postalSalutation }}</label>
      </w-column>
    </w-row>
  </div>
</template>

<script>
import readonlyMixin from '@/components/global_components/layout/readonly/readonly-mixin';

export default {
  name: 'WorkContactReadonlyLayout',
  mixins: [readonlyMixin],
  props: {
    withUserDataTitle: { type: Boolean, default: true },
    removePadding: { type: Boolean, default: true },
    // fields
    salutation: { type: String, required: false },
    title: { type: String, required: false },
    firstname: { type: String, required: false },
    lastname: { type: String, required: false },
    birthday: { type: String, required: false },
    postalSalutation: { type: String, required: false },
  },
  computed: {
    classes() {
      return {
        'w-readonly-layout': true,
        'w-user-data-readonly-layout': true,
        'no-spacing': this.removePadding
      }
    },
    showSalutationField() {
      return this.valueHandedAndFilled(this.salutation);
    },
    showTitleField() {
      return this.valueHandedAndFilled(this.title);
    },
    showNameField() {
      return this.valueHandedAndFilled(this.firstname) || this.valueHandedAndFilled(this.lastname);
    },
    showBirthdayField() {
      return this.valueHandedAndFilled(this.birthday);
    },
    showPostalSalutationField() {
      return this.valueHandedAndFilled(this.postalSalutation);
    },
  }
};
</script>

<style lang='scss' scoped>
@import "WReadonlyLayout";
</style>
